import type { TourDefinition } from '../types';

export const dashboardTour: TourDefinition = {
  id: 'dashboard',
  title: 'Dashboard',
  steps: [
    {
      element: '[data-tour="dashboard-date-range"]',
      popover: {
        title: 'Período de Análise',
        description:
          'Selecione o período para filtrar todos os indicadores do dashboard.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="dashboard-kpi-cards"]',
      popover: {
        title: 'Indicadores Principais',
        description:
          'Acompanhe receita, deals ganhos, taxa de conversão, ticket médio e atividades. Clique em qualquer card para ver detalhes.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="dashboard-tabs"]',
      popover: {
        title: 'Abas de Análise',
        description:
          'Alterne entre Visão Geral, Funil Operacional e Cadências para diferentes perspectivas.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dashboard-funnel"]',
      popover: {
        title: 'Funil de Vendas',
        description:
          'Visualize a distribuição dos seus negócios por etapa do pipeline.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="dashboard-charts"]',
      popover: {
        title: 'Gráficos de Evolução',
        description:
          'Acompanhe a evolução das suas atividades e comparativos mensais.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
